import styled from 'styled-components';

const MainContainer = styled.main`
  display: flex;
  justify-content: center;
`;

export {
  MainContainer,
};
